var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRegenerateIcon = function SvgRegenerateIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.3.2.10.1-All-screenings-/-View-action-/-Station---default-(temporary)",
    transform: "translate(-1199.000000, -531.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/09.Web/07.View-action/3-row/Right",
    transform: "translate(1183.000000, 282.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(16.000000, 249.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3682848,3.18640268 L12.9724515,5.79056936 C13.1758495,5.99396743 13.1758495,6.32374086 12.9724515,6.52713893 L10.3682848,9.13130561 C10.1648867,9.33470368 9.83511329,9.33470368 9.63171522,9.13130561 C9.42831715,8.92790754 9.42831715,8.59813411 9.63171522,8.39473604 L11.4238333,6.60085413 L11.3483736,6.59415611 C11.0207624,6.56525306 10.5744564,6.54947915 10,6.54947915 C7.41116522,6.54947915 5.31249998,8.6481444 5.31249998,11.2369792 C5.31249998,13.825814 7.41116522,15.9244792 10,15.9244792 C12.5629464,15.9244792 14.6454777,13.8675774 14.686872,11.3144956 L14.6875,11.2369792 C14.6875,10.9493309 14.9206851,10.7161458 15.2083334,10.7161458 C15.4959817,10.7161458 15.7291667,10.9493309 15.7291667,11.2369792 C15.7291667,14.4011106 13.1641314,16.9661459 10,16.9661459 C6.8358686,16.9661459 4.2708333,14.4011106 4.2708333,11.2369792 C4.2708333,8.07284778 6.8358686,5.50781248 10,5.50781248 L10.0811109,5.50781248 C10.5459621,5.50894128 10.9322272,5.51960849 11.2510685,5.54128644 L9.63171522,3.92297225 C9.43114212,3.72239916 9.42835638,3.39893675 9.623358,3.19495006 L9.63171522,3.18640268 C9.83511329,2.98300461 10.1648867,2.98300461 10.3682848,3.18640268 Z",
    id: "Combined-Shape",
    fill: "#666666",
    mask: "url(#mask-2)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRegenerateIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/regenerate-icon.b1e8eb46.svg";
export { ForwardRef as ReactComponent };